import { useEffect } from 'react';

type JsonLdData = Record<string, unknown> | Record<string, unknown>[];

export function useJsonLd(data: JsonLdData): void {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-react-json-ld', 'page');
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
